import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientPaginationPipe } from './patient-pagination.pipe';

import { HeaderComponent } from './header/header.component';
import { LogoComponent } from './header/logo/logo.component';

import { TranslateModule } from '@ngx-translate/core';
import { WfLogoComponent } from 'Shared/app/components/wfs-wf-logo/wf-logo.component';
import { LanguagePickerComponent } from './language-picker/language-picker.component';
import { SpinnerLoaderComponent } from 'Shared/app/components/wfs-spinner-loader/spinner-loader.component';
import { RouterModule } from '@angular/router';
import { FormButtonComponent } from 'Shared/app/components/wfs-form-button/form-button.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [HeaderComponent, LogoComponent, LanguagePickerComponent, PatientPaginationPipe],
  imports: [
    CommonModule,
    TranslateModule,
    WfLogoComponent,
    SpinnerLoaderComponent,
    RouterModule,
    FormButtonComponent,
    MatSnackBarModule
  ],
  providers: [],
  exports: [
    HeaderComponent,
    LogoComponent,
    CommonModule,
    TranslateModule,
    PatientPaginationPipe,
    LanguagePickerComponent,
    SpinnerLoaderComponent,
    WfLogoComponent,
    MatSnackBarModule
  ]
})
export class SharedModule {}
